import React from 'react';
import { useNavigate } from 'react-router-dom';

import NotFoundIllustration from '@/assets/images/not-found-404.svg';
import { Button } from '@/components/core';
import { useScreenSize } from '@/hooks/useScreenSize';

const pageBackground = {
  backgroundImage:
    'radial-gradient(ellipse 62% 58% at 34% 38%, rgba(26,84,235,0.32) 0%, rgba(8,47,151,0.18) 34%, rgba(0,13,78,0) 68%), linear-gradient(180deg, rgba(0,20,101,1) 0%, rgba(0,1,58,1) 100%)',
};

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { getSize } = useScreenSize();
  const size = getSize;

  return (
    <section
      className="flex min-h-screen w-full items-center justify-center overflow-hidden px-6 py-16 text-color-content-text-primary md:px-10 md:py-20 lg:px-[70px] lg:py-12"
      style={pageBackground}
    >
      <div className="flex w-full max-w-[1024px] flex-col items-center gap-8 text-center lg:pt-0">
        <img
          src={NotFoundIllustration}
          alt="404 illustration"
          className="w-full max-w-[236px] md:max-w-[252px] lg:max-w-[269px]"
        />
        <div className="flex w-full max-w-[640px] flex-col items-center justify-center gap-10 lg:min-h-[230px] lg:gap-14">
          <div className="flex w-full flex-col items-center gap-4">
            <div className="flex w-full flex-col items-center gap-2">
              <h1 className="w-full font-font-family-primary text-[32px] font-[900] leading-[40px] text-color-content-text-primary md:text-[40px] md:leading-[48px] lg:text-[36px]">
                Oops...
              </h1>
            </div>
            <p className="w-full max-w-[620px] font-font-family-primary text-[16px] font-[450] leading-[28px] text-color-content-text-secondary md:text-[20px] lg:text-[18px]">
              We couldn't find that page, but we can find you something great to watch.
            </p>
          </div>
          <Button
            size={size}
            variant="primary"
            className="min-w-[128px] px-7"
            onClick={() => navigate('/#content')}
          >
            Explore
          </Button>
        </div>
      </div>
    </section>
  );
};

export default NotFoundPage;
